import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SCartItemDto } from "@/__generated__/sdk";

export const useCart = () => useAppSelector((state) => state.cart);

export const useCartHasProduct = (productId: string): Boolean =>
  useAppSelector((state) => Boolean(state?.cart?.cart?.cartItems.some((s) => s.product.id === productId)));

export const useCartItem = (variantId: number): SCartItemDto | null =>
  useAppSelector((state) => {
    return state.cart?.cart?.cartItems.find((a) => +a.variant.id === +variantId) || null;
  });

export const useCartActiveVariant = (productId: string): SCartItemDto | null =>
  useAppSelector((state) => {
    return state.cart?.cart?.cartItems.find((a) => a.product.id === productId) || null;
  });
